import { CollectionState, Filter, FiltersMap } from '@wix/bex-core';

export interface EagerLazyModeOptions {
  fetchAllThreshold: number;
  expandAllThreshold: number;
}

export interface NodeCollection<T, F extends FiltersMap> {
  collection: CollectionState<T, F>;
  parentFilter?: Filter<string[]>;
}
